import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { polyfill } from 'seamless-scroll-polyfill';
import { fetchHtml } from 'lib/common/fetcher';
import Config from 'config';
import { filter, forEach, get, groupBy, orderBy, uniq, uniqBy } from 'lodash';
import svgClasses from 'lib/common/svgClasses';
import ReactTooltip from 'react-tooltip';
import { toCurrency } from 'lib/common/displayHelpers';
import BALevelSelectMap from 'components/BALevelSelectMap';
import NumberSelector from 'components/NumberSelector';
import LoadingSpinner from 'components/LoadingSpinner';
import PromoCode from 'components/PromoCode';
import features from 'lib/common/features';

import API from 'lib/tessitura/API';
import arrayWrap from '../lib/common/arrayWrap';
import filterPastPerformances from '../lib/common/filterPastPerformances';
import formattedDate from '../lib/common/formattedDate';
import Modal from 'components/Modal';
import AccessibleSeatSelector from 'components/AccessibleSeatSelector';
import detectAccessibilitySeat from '../lib/seats/detectAccessibilitySeat';
import { transformID } from '../lib/seatmaps/levelBASelectorHelper';

import { CONFIRM_BUTTON_STATES, CONTEXT } from 'constants';
import isMobile from '../lib/common/isMobile';
import { getHoldCodeToBook } from '../lib/tessitura/common/helpers';
import detectCompanionSeat from '../lib/seats/detectCompanionSeat';
import displayTitle from '../lib/common/displayTitle';
import panZoom from '../behaviours/panZoom';

let config;

class LevelBASelectorContainer extends Component {
  constructor(props) {
    super(props);
    config = new Config().getConfig();

    this.state = {
      currentPerformanceId: props.initialPerformanceId,
      imageMask: null,
      isInactive: true,
      activeMask: null,
      sectionMapping: props.sectionMapping,
      numberOfTickets: 2,
      frozen: false,
      performances: props.performances,
      unmount: false,
      details: props.details,
      priceTypes: this.preparePriceZonesFromPriceTypes(props.priceTypes),
      selectedZone: props.selectedZone,
      loading: true,
      //screenZones: props.screenZones,
      numberOfAccessibleSeats: 0,
      availablePriceTypes: this.getAvailablePriceTypes(props.priceTypes),
      selectedScreen: null,
      totalPrice: 0,
      selectedPriceTypes: [],
      priceZones: [],
      buttonState: CONFIRM_BUTTON_STATES.CONFIRM,
      displaySeatMapAfterBooking: false,
      ticketsLimit: this.props.maxTickets,
      maxTickets: 10
    };

    if (
      this.state.ticketsLimit === undefined ||
      this.state.ticketsLimit.zones === undefined
    ) {
      this.state.ticketsLimit = {};
    }

    if (this.state.ticketsLimit.default === undefined) {
      this.state.ticketsLimit.default = 10;
    }

    this.state.maxTickets = this.state.ticketsLimit.default;

    this.handlePriceHover = this.handlePriceHover.bind(this);
    this.handlePriceClick = this.handlePriceClick.bind(this);
    this.handleTicketPriceAmount = this.handleTicketPriceAmount.bind(this);
    this.handleAccessibleSeatAmount = this.handleAccessibleSeatAmount.bind(
      this
    );
    this.reserveBestAvailableSeats = this.reserveBestAvailableSeats.bind(this);
    this.renderEnhancedNotice = this.renderEnhancedNotice.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSectionPriceTypeHovered = this.onSectionPriceTypeHovered.bind(this);
    this.onSectionPriceTypeSelected = this.onSectionPriceTypeSelected.bind(
      this
    );
    this.loadSeatMap = this.loadSeatMap.bind(this);
    this.handleAddSectionClick = this.handleAddSectionClick.bind(this);
    this.handleAddSectionHover = this.handleAddSectionHover.bind(this);
    this.handleRemoveSectionHover = this.handleRemoveSectionHover.bind(this);
    this.getAvailablePriceTypes = this.getAvailablePriceTypes.bind(this);
    this.preparePriceZonesFromPriceTypes = this.preparePriceZonesFromPriceTypes.bind(
      this
    );
  }

  componentDidMount() {
    this.loadSeatMap();

    this.handleTicketPriceAmount(
      this.state.numberOfTickets,
      this.state.availablePriceTypes[0]
    );

    this.setState({
      screenZones: this.parseScreenZones()
    });
  }

  getAvailablePriceTypes(priceTypes) {
    let newPriceTypes = priceTypes
      .filter(pt => pt.avail_count > 0)
      .slice()
      .map(pt => {
        let npt = { ...pt };

        if (npt.zones) {
          let zones = npt.zones.slice();

          priceTypes.forEach(ptm => {
            if (npt.description === ptm.description && ptm.zones) {
              ptm.zones.forEach(z => zones.push(z));
            }
          });

          npt.zones = uniq(zones);
        }

        return npt;
      });

    return uniqBy(newPriceTypes, 'description');
  }

  getNewBestAvailableItem(priceZone) {
    let item = {
      count: 0,
      avail_count: 0,
      available: false,
      priceText: '',
      zones: [],

      description: priceZone.description,
      price_type_desc: priceZone.price_type_desc,
      perf_no: priceZone.perf_no,
      pkg_no: priceZone.pkg_no,
      price_type: priceZone.price_type,
      is_default: priceZone.is_default,

      base_price: undefined,
      highlighted: false,
      price: null,
      selected: false,
      zone_desc: 'Any Best Available Seat',
      zone_no: 0,
      zone_rank: 999
    };

    return item;
  }

  preparePriceZonesFromPriceTypes(priceTypes) {
    let levelSelectorConfig = this.props.levelSelectorConfig;
    let priceZonesByIndex = {};
    let mergedPriceZones = [];

    let bestAvailableItems = {};

    priceTypes.forEach(priceType => {
      let zoneDesc =
        levelSelectorConfig &&
        levelSelectorConfig.mergePriceZones &&
        levelSelectorConfig.mergePriceZones[priceType.zone_desc]
          ? levelSelectorConfig.mergePriceZones[priceType.zone_desc]
          : priceType.zone_desc;

      let index = `${priceType.price}-${priceType.price_type}-${zoneDesc}`;

      config = new Config().getConfig();
      priceType.avail_count = this.props.seatData.reduce((acc, seat) => {
        if (
          seat.zone_no === priceType.zone_no &&
          config.seatTypes.seatMappings
            .filter(mapping => mapping.status === 'available')
            .map(mapping => mapping.statusCode)
            .indexOf(seat.seat_status.status_code) !== -1
        ) {
          acc = acc + 1;
        }
        return acc;
      }, 0);

      if (priceZonesByIndex[index] === undefined) {
        priceType.zone_desc = zoneDesc;
        priceType.zones = priceType.zones
          ? priceType.zones
          : [priceType.zone_no];
        priceZonesByIndex[index] = priceType;
      } else {
        if (priceType.avail_count > 0) {
          if (priceType.avail_count > priceZonesByIndex[index].avail_count) {
            priceZonesByIndex[index].avail_count = priceType.avail_count;
            priceZonesByIndex[index].zone_no = priceType.zone_no;
          }
          if (
            priceZonesByIndex[index].zones.indexOf(priceType.zone_no) === -1
          ) {
            let zones = priceZonesByIndex[index].zones;
            zones.push(priceType.zone_no);
            priceZonesByIndex[index].zones = zones;
          }
        }
      }
    });

    Object.keys(priceZonesByIndex).forEach(key => {
      mergedPriceZones.push(priceZonesByIndex[key]);
    });

    mergedPriceZones.forEach(priceZone => {
      if (bestAvailableItems[priceZone.price_type] === undefined) {
        bestAvailableItems[priceZone.price_type] = {
          min: false,
          max: false,
          item: this.getNewBestAvailableItem(priceZone)
        };
      }

      if (priceZone.avail_count >= 2) {
        if (
          bestAvailableItems[priceZone.price_type].min === false ||
          bestAvailableItems[priceZone.price_type].min >
            parseFloat(priceZone.price)
        ) {
          bestAvailableItems[priceZone.price_type].min = parseFloat(
            priceZone.price
          );
        }

        if (
          bestAvailableItems[priceZone.price_type].max === false ||
          bestAvailableItems[priceZone.price_type].max <
            parseFloat(priceZone.price)
        ) {
          bestAvailableItems[priceZone.price_type].max = parseFloat(
            priceZone.price
          );
        }

        bestAvailableItems[priceZone.price_type].item.priceText = `${toCurrency(
          bestAvailableItems[priceZone.price_type].min
        )} - ${toCurrency(bestAvailableItems[priceZone.price_type].max)}`;
        bestAvailableItems[
          priceZone.price_type
        ].item.zones = bestAvailableItems[
          priceZone.price_type
        ].item.zones.concat(priceZone.zones);

        if (
          bestAvailableItems[priceZone.price_type].item.count < priceZone.count
        ) {
          bestAvailableItems[priceZone.price_type].item.count = priceZone.count;
        }

        if (
          bestAvailableItems[priceZone.price_type].item.avail_count <
          priceZone.avail_count
        ) {
          bestAvailableItems[priceZone.price_type].item.avail_count =
            priceZone.avail_count;
        }

        if (priceZone.available == true) {
          bestAvailableItems[priceZone.price_type].item.available = true;
        }
      }
    });

    Object.keys(bestAvailableItems).forEach(key => {
      mergedPriceZones.push(bestAvailableItems[key].item);
    });

    return mergedPriceZones.sort((a, b) => {
      if (a.zone_rank < b.zone_rank) {
        return -1;
      }

      if (a.zone_rank > b.zone_rank) {
        return 1;
      }

      return 0;
    });
  }

  loadSeatMap() {
    if (!this.props.useSectionGraphic) {
      this.setState({
        loading: false
      });

      return false;
    }

    fetchHtml(this.props.levelSelectorConfig.sectionGraphic).then(
      sectionGraphic => {
        this.setState({
          sectionGraphic: sectionGraphic,
          sectionMapping: this.props.levelSelectorConfig.sectionMap,
          loading: false
        });
        let { svgEl, sections, sectionLabels } = this._selectMapRefs;
        if (sections) {
          let zoomControlsOptions = features.getOption('panZoom', 'options');
          panZoom(svgEl, zoomControlsOptions);

          let enhancedSections = this.enhanceSectionMap(
            sections,
            sectionLabels
          );
          this.setState(
            {
              sections: enhancedSections,
              sectionLabels: sectionLabels
            },
            () => {
              this.addSectionHover();
              this.removeSectionHover();
              this.addSectionClick();

              this.setState({
                screenZones: this.parseScreenZones()
              });
            }
          );
        }
      }
    );
  }

  freeze() {
    this.setState({ frozen: true });
  }

  thaw() {
    this.setState({ frozen: false });
  }

  onSectionPriceTypeHovered(zones) {
    let newPricetypes = this.state.priceTypes.reduce((acc, priceType) => {
      priceType.highlighted = zones.some(
        zone => priceType.zones.indexOf(zone) !== -1
      );
      acc.push(priceType);
      return acc;
    }, []);
    this.setState({
      priceTypes: newPricetypes
    });
  }

  onSectionPriceTypeSelected(item) {
    forEach(this.state.sections, section => {
      svgClasses.removeClass(section.section, 'highlight-selected');

      if (this.state.sectionLabels.length > 0) {
        forEach(this.state.sectionLabels, item => {
          if (item.id === `Label_${section.section.id}`) {
            svgClasses.removeClass(item, 'highlight-selected');
          }
        });
      }
    });

    let newPricetypes = this.state.priceTypes.reduce((acc, priceType) => {
      priceType.selected = item === priceType;
      priceType.highlightSelected = false;
      acc.push(priceType);
      return acc;
    }, []);

    let itemZonesWithLimits = item.zones.filter(
      zone_no => !!this.state.ticketsLimit.zones[zone_no]
    );
    if (itemZonesWithLimits.length > 0) {
      this.setState({
        maxTickets: this.state.ticketsLimit.zones[itemZonesWithLimits[0]]
      });
    } else {
      this.setState({
        maxTickets: this.state.ticketsLimit.default
      });
    }

    this.setState({
      priceTypes: newPricetypes,
      selectedZone: item.selected ? item : undefined
    });
  }

  checkIfElementIsInView(element) {
    let elDimensions = element.getBoundingClientRect();
    let top = elDimensions.top;
    let bottom = elDimensions.bottom;

    return top >= 0 && bottom <= window.innerHeight;
  }

  // Add click events on the svg <g> elements.
  // Manages freeze/thaw state
  addSectionClick() {
    forEach(this.state.sections, sectionObj => {
      sectionObj.section.removeEventListener(
        'click',
        this.handleAddSectionClick
      );
      sectionObj.section.addEventListener('click', this.handleAddSectionClick);
    });
  }

  handleAddSectionClick(e) {
    e.preventDefault();
    let target = e.target;
    if (target.tagName.toLowerCase() !== 'g') {
      target = target.closest('g');
    }

    let sectionObj = this.state.sections.find(
      sectionObj => sectionObj.section === target
    );

    forEach(this.state.sections, section => {
      svgClasses.removeClass(section.section, 'selected');

      forEach(this.state.sectionLabels, item => {
        if (item.id === `Label_${section.section.id}`) {
          svgClasses.removeClass(item, 'selected');
        }
      });

      svgClasses.removeClass(section.section, 'highlight-selected');

      forEach(this.state.sectionLabels, item => {
        if (item.id === `Label_${section.section.id}`) {
          svgClasses.removeClass(item, 'highlight-selected');
        }
      });
    });

    let processed = false;

    forEach(sectionObj.screenZones.zones, zone => {
      let foundSections = filter(this.state.sections, statesection => {
        return statesection.screenZones.zones.indexOf(zone) !== -1;
      });

      // we only need to process this once. no need to redraw or update
      // stylings n number of times.
      if (foundSections.length > 0 && !processed) {
        let availablePriceTypes = filter(
          this.state.priceTypes,
          priceType =>
            priceType.highlighted &&
            typeof priceType.isAvailable !== 'undefined' &&
            priceType.isAvailable
        );

        let state =
          availablePriceTypes.length > 1 ? 'highlight-selected' : 'selected';

        if (availablePriceTypes.length > 1) {
          let newPricetypes = this.state.priceTypes.reduce((acc, priceType) => {
            let isHighlighted =
              foundSections[0].screenZones.zones.indexOf(priceType.zone_no) !==
              -1;
            priceType.highlighted = isHighlighted;
            priceType.highlightSelected =
              isHighlighted && state === 'highlight-selected';
            priceType.selected =
              priceType.zone_no === availablePriceTypes[0].zone_no;
            acc.push(priceType);
            return acc;
          }, []);

          this.setState({
            priceTypes: newPricetypes,
            selectedZone: availablePriceTypes[0]
          });

          if (isMobile() && newPricetypes && newPricetypes.length > 0) {
            polyfill();
            let selectedPriceType = newPricetypes.find(item => item.selected);
            if (selectedPriceType) {
              let element = document.querySelector(
                '.syos-level-selector-price-types__item.selected .syos-button.syos-pricetype__button'
              );
              if (!this.checkIfElementIsInView(element)) {
                setTimeout(function() {
                  element = element.closest(
                    '.syos-level-selector-price-types__item'
                  );
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                  });
                }, 100);
              }
            }
          }
        } else {
          let newPricetypes = this.state.priceTypes.reduce((acc, priceType) => {
            priceType.selected = priceType.highlighted;
            priceType.highlightSelected = false;
            acc.push(priceType);
            return acc;
          }, []);

          this.setState({
            priceTypes: newPricetypes,
            selectedZone: availablePriceTypes[0]
          });

          if (isMobile() && newPricetypes && newPricetypes.length > 0) {
            polyfill();
            let selectedPriceType = newPricetypes.find(item => item.selected);
            if (selectedPriceType) {
              let element = document.querySelector(
                '.syos-level-selector-price-types__item.selected .syos-button.syos-pricetype__button'
              );
              if (!this.checkIfElementIsInView(element)) {
                setTimeout(function() {
                  element = element.closest(
                    '.syos-level-selector-price-types__item'
                  );
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                  });
                }, 100);
              }
            }
          }
        }

        let itemZonesWithLimits = availablePriceTypes[0].zones.filter(
          zone_no => !!this.state.ticketsLimit.zones[zone_no]
        );
        if (itemZonesWithLimits.length > 0) {
          this.setState({
            maxTickets: this.state.ticketsLimit.zones[itemZonesWithLimits[0]]
          });
        } else {
          this.setState({
            maxTickets: this.state.ticketsLimit.default
          });
        }

        processed = true;

        forEach(foundSections, foundSection => {
          svgClasses.addClass(foundSection.section, state);

          forEach(this.state.sectionLabels, item => {
            if (item.id === `Label_${foundSection.section.id}`) {
              svgClasses.addClass(item, state);
            }
          });
        });
      }
    });
  }

  removeSectionHover() {
    forEach(this.state.sections, sectionObj => {
      sectionObj.section.removeEventListener(
        'mouseleave',
        this.handleRemoveSectionHover
      );
      sectionObj.section.addEventListener(
        'mouseleave',
        this.handleRemoveSectionHover
      );
    });
  }

  handleRemoveSectionHover(e) {
    e.preventDefault();
    let target = e.target;
    if (target.tagName.toLowerCase() !== 'g') {
      target = target.closest('g');
    }

    let sectionObj = this.state.sections.find(
      sectionObj => sectionObj.section === target
    );
    if (!this.state.frozen) {
      this.onSectionPriceTypeHovered([]);
      forEach(sectionObj.screenZones.zones, zone => {
        let foundSections = filter(this.state.sections, statesection => {
          return statesection.screenZones.zones.indexOf(zone) !== -1;
        });
        if (foundSections.length > 0) {
          forEach(foundSections, foundSection => {
            svgClasses.removeClass(foundSection.section, 'highlight');

            forEach(this.state.sectionLabels, item => {
              if (item.id === `Label_${foundSection.section.id}`) {
                svgClasses.removeClass(item, 'highlight');
              }
            });
          });
        }
      });
    }
  }

  addSectionHover() {
    forEach(this.state.sections, sectionObj => {
      sectionObj.section.removeEventListener(
        'mouseover',
        this.handleAddSectionHover
      );
      sectionObj.section.addEventListener(
        'mouseover',
        this.handleAddSectionHover
      );
    });
  }

  handleAddSectionHover(e) {
    e.preventDefault();
    let target = e.target;
    if (target.tagName.toLowerCase() !== 'g') {
      target = target.closest('g');
    }

    let sectionObj = this.state.sections.find(
      sectionObj => sectionObj.section === target
    );
    this.onSectionPriceTypeHovered(sectionObj.screenZones.zones);
    forEach(sectionObj.screenZones.zones, zone => {
      let foundSections = filter(this.state.sections, statesection => {
        return statesection.screenZones.zones.indexOf(zone) !== -1;
      });

      if (foundSections.length > 0) {
        forEach(foundSections, foundSection => {
          svgClasses.addClass(foundSection.section, 'highlight');

          if (this.state.sectionLabels.length > 0) {
            forEach(this.state.sectionLabels, item => {
              if (item.id === `Label_${foundSection.section.id}`) {
                svgClasses.addClass(item, 'highlight');
              }
            });
          }
        });
      }
    });
  }

  enhanceSectionMap(sections, sectionLabels) {
    let sections_array = [];
    // sections is a nodelist so we convert to an array
    // to use reduce & return a new collection
    forEach(sections, section => {
      sections_array.push(section);
    });

    // set the configuration for the sections
    // and return the array
    return sections_array.reduce((acc, section) => {
      //let data = section.dataset;
      let hasScreen = !!section.id;

      svgClasses.removeClass(section, 'has-zones');
      svgClasses.addClass(section, 'unavailable');

      forEach(section.children, path => {
        path.setAttribute('aria-label', section.id.replace(/_/g, ' '));
      });

      forEach(sectionLabels, item => {
        if (item.id === `Label_${section.id}`) {
          svgClasses.addClass(item, 'unavailable');
        }
        if (item.tagName === 'g') {
          forEach(item.children, text => {
            text.setAttribute('aria-hidden', true);
          });
        } else {
          item.setAttribute('aria-hidden', true);
        }
      });

      if (hasScreen) {
        let screens = null;
        let screenZones = this.state.screenZones[transformID(section.id)];
        let isAvailable = false;

        let availablePriceTypes = this.state.priceTypes.filter(
          pt =>
            typeof pt.isAvailable !== 'undefined' &&
            pt.isAvailable &&
            pt.zone_no > 0
        );
        if (!screenZones) {
          screens = this.props.levelSelectorConfig.screenMap;
          if (screens && screens[section.id]) {
            let screen = screens[section.id];

            screenZones = {
              zones: [],
              element: [],
              availableSeats: 0,
              availableAccessibleSeats: 0,
              availableCompanionSeats: 0,
              availableHoldCodesSeats: 0,
              availableHoldCodesSeatsMap: []
            };

            screen.forEach(scr => {
              let screenData = this.state.screenZones[scr];

              if (screenData) {
                screenData.zones.forEach(elem => screenZones.zones.push(elem));
                screenData.element.forEach(elem =>
                  screenZones.element.push(elem)
                );
                screenData.availableHoldCodesSeatsMap.forEach(elem =>
                  screenZones.availableHoldCodesSeatsMap.push(elem)
                );
                screenZones.availableSeats += screenData.availableSeats;
                screenZones.availableAccessibleSeats +=
                  screenData.availableAccessibleSeats;
                screenZones.availableCompanionSeats +=
                  screenData.availableCompanionSeats;
                screenZones.availableHoldCodesSeats +=
                  screenData.availableHoldCodesSeats;
              }
            });

            screenZones.zones = uniq(screenZones.zones);

            if (
              screenZones.availableSeats +
                (this.state.numberOfAccessibleSeats > 0
                  ? screenZones.availableCompanionSeats
                  : 0) >=
                this.state.numberOfTickets -
                  this.state.numberOfAccessibleSeats &&
              screenZones.availableAccessibleSeats >=
                this.state.numberOfAccessibleSeats &&
              availablePriceTypes.length > 0 &&
              availablePriceTypes.some(pt =>
                screenZones.zones.some(szs => pt.zones.indexOf(szs) > -1)
              )
            ) {
              isAvailable = true;
            }
          }
        } else {
          if (
            screenZones.availableSeats +
              (this.state.numberOfAccessibleSeats > 0
                ? screenZones.availableCompanionSeats
                : 0) >=
              this.state.numberOfTickets - this.state.numberOfAccessibleSeats &&
            screenZones.availableAccessibleSeats >=
              this.state.numberOfAccessibleSeats &&
            availablePriceTypes.length > 0 &&
            availablePriceTypes.some(pt =>
              screenZones.zones.some(szs => pt.zones.indexOf(szs) > -1)
            )
          ) {
            isAvailable = true;
          }
        }

        if (screenZones) {
          screenZones.zones.forEach(zone_no => {
            if (this.state.numberOfTickets > this.state.ticketsLimit.default) {
              isAvailable = false;
            }

            if (
              this.state.ticketsLimit.zones &&
              this.state.ticketsLimit.zones[zone_no] &&
              this.state.ticketsLimit.zones[zone_no] <
                this.state.numberOfTickets - this.state.numberOfAccessibleSeats
            ) {
              isAvailable = false;
            }
          });

          if (this.state.numberOfTickets > 0 && isAvailable) {
            svgClasses.addClass(section, 'has-zones');
            svgClasses.removeClass(section, 'unavailable');

            if (sectionLabels.length > 0) {
              forEach(sectionLabels, item => {
                if (item.id === `Label_${section.id}`) {
                  svgClasses.removeClass(item, 'unavailable');
                }
              });
            }
          }

          acc.push({
            section: section,
            screenZones: isAvailable
              ? screenZones
              : {
                  zones: [],
                  element: [],
                  availableSeats: 0,
                  availableAccessibleSeats: 0,
                  availableCompanionSeats: 0,
                  availableHoldCodesSeats: 0,
                  availableHoldCodesSeatsMap: []
                },
            screen: section.id
          });
        }
      }
      return acc;
    }, []);
  }

  // handles cicking on the price types list
  // passes value to the AppContainer so we can track selection at higher level
  // & manages highlights of svg <g> elements
  handlePriceClick(price_type) {
    this.onSectionPriceTypeSelected(price_type);
    let sections = this.state.sections;

    // remove all the selected sates initially
    forEach(sections, sec => {
      svgClasses.removeClass(sec.section, 'selected');

      forEach(this.state.sectionLabels, item => {
        if (item.id === `Label_${sec.section.id}`) {
          svgClasses.removeClass(item, 'selected');
        }
      });
    });

    // then add selected class to <g> elements which have the price type zone_no
    if (price_type !== undefined && price_type.selected) {
      forEach(sections, sec => {
        if (
          price_type.zones.some(
            zone_no => sec.screenZones.zones.indexOf(zone_no) !== -1
          )
        ) {
          svgClasses.addClass(sec.section, 'selected');

          forEach(this.state.sectionLabels, item => {
            if (item.id === `Label_${sec.section.id}`) {
              svgClasses.addClass(item, 'selected');
            }
          });

          this.setState({
            selectedScreen: sec.screen
          });
        }
      });
    }
  }

  handlePriceHover(priceType) {
    if (!this.state.sections) {
      return false;
    }

    let selectedScreens = [];
    if (!this.state.frozen) {
      if (priceType !== undefined) {
        // find all of the screens that have zones that match the selected price type zone_no
        // and return an array of the screens
        selectedScreens = this.state.sections.reduce((acc, sec) => {
          svgClasses.removeClass(sec.section, 'highlight');
          if (
            priceType.zones.some(
              zone_no => sec.screenZones.zones.indexOf(zone_no) !== -1
            )
          ) {
            acc.push(sec);
          }
          return acc;
        }, []);

        // loop through the selectedScreens and highlight
        // the <g> elements. (the 'section' key)
        forEach(selectedScreens, screen => {
          this.onSectionPriceTypeHovered([]);
          svgClasses.addClass(screen.section, 'highlight');
        });
      } else {
        let sections = this.state.sections;
        this.onSectionPriceTypeHovered([]);
        forEach(sections, screen => {
          svgClasses.removeClass(screen.section, 'highlight');
        });
      }
    }
  }

  renderPriceTypesList() {
    let min = false;
    let max = false;
    let anyAvailable = false;
    let hasDefault = this.state.priceTypes.some(
      item => item.is_default && item.zone_desc !== 'Any Best Available Seat'
    );

    return this.state.priceTypes ? (
      <div className="syos-level-selector-price-types">
        {this.state.priceTypes.map((item, index) => {
          {
            item.isAvailable =
              this.state.numberOfTickets <= this.state.ticketsLimit.default &&
              this.state.numberOfTickets > 0 &&
              item.avail_count > 0 &&
              item.zones.some(zone_no =>
                Object.keys(
                  this.state.screenZones ? this.state.screenZones : {}
                ).find(
                  key =>
                    this.state.screenZones[key] &&
                    this.state.screenZones[key].zones.indexOf(zone_no) !== -1 &&
                    this.state.screenZones[key].availableSeats +
                      (this.state.numberOfAccessibleSeats > 0
                        ? this.state.screenZones[key].availableCompanionSeats
                        : 0) >=
                      this.state.numberOfTickets -
                        this.state.numberOfAccessibleSeats &&
                    this.state.screenZones[key].availableAccessibleSeats >=
                      this.state.numberOfAccessibleSeats &&
                    this.state.availablePriceTypes
                      .filter(apt => apt.count > 0)
                      .every(apt => apt.zones.indexOf(zone_no) > -1) &&
                    (!this.state.ticketsLimit.zones ||
                      !this.state.ticketsLimit.zones[zone_no] ||
                      this.state.ticketsLimit.zones[zone_no] >=
                        this.state.numberOfTickets -
                          this.state.numberOfAccessibleSeats)
                )
              );

            if (item.zone_no === 0) {
              item.available = anyAvailable;

              if (min === false || max === false) {
                item.priceText = '';
              } else {
                if (min !== max) {
                  item.priceText = `${toCurrency(min)} - ${toCurrency(max)}`;
                } else {
                  item.priceText = toCurrency(min);
                }
              }
            } else {
              if (item.isAvailable) {
                anyAvailable = true;
                if (min === false || min > parseFloat(item.price)) {
                  min = parseFloat(item.price);
                }

                if (max === false || max < parseFloat(item.price)) {
                  max = parseFloat(item.price);
                }
              }
            }

            return (hasDefault && item.is_default) ||
              (this.state.selectedPriceTypes.length > 0
                ? !hasDefault &&
                  this.state.selectedPriceTypes[0] === item.price_type
                : !hasDefault &&
                  this.state.availablePriceTypes.length > 0 &&
                  this.state.availablePriceTypes[0].price_type ===
                    item.price_type) ? (
              <div
                tabIndex={item.zone_rank === 999 ? 5 : 6}
                className={classnames({
                  'syos-level-selector-price-types__item': true,
                  'has-availability':
                    this.renderPriceTypeLimitedAvailbilityText(item) !== null,
                  highlighted: item.highlighted,
                  selected: item.selected,
                  'not-available': !item.isAvailable,
                  'highlight-selected': item.highlightSelected,
                  'bestavailable-order': item.zone_no === 0
                })}
                key={index}
                onMouseEnter={() =>
                  item.isAvailable ? this.handlePriceHover(item) : null
                }
                onMouseLeave={() =>
                  item.isAvailable ? this.handlePriceHover() : null
                }
                onClick={() =>
                  item.isAvailable ? this.handlePriceClick(item) : null
                }
                onKeyDown={e => {
                  const code = e.charCode || e.keyCode || e.which;
                  [13, 32].indexOf(code) !== -1
                    ? this.handlePriceClick(item)
                    : null;
                }}
              >
                <div
                  className={classnames({
                    'syos-level-selector-price-types__item__contents': true
                  })}
                >
                  <span className="zone">{item.zone_desc}</span>
                  {!item.isAvailable && (
                    <span className="sr-only">.No Available.</span>
                  )}
                  <span className="price">
                    {item.priceText !== undefined
                      ? item.priceText
                      : toCurrency(item.price)}
                  </span>
                  <button
                    tabIndex={item.zone_rank === 999 ? 5 : 6}
                    className="syos-button syos-pricetype__button"
                    disabled={
                      !this.state.selectedZone || this.state.numberOfTickets < 1
                    }
                    onClick={() => {
                      this.reserveBestAvailableSeats();
                    }}
                  >
                    Get Seats -{' '}
                    {item.priceText !== undefined
                      ? item.priceText
                      : toCurrency(item.price)}
                  </button>
                </div>
                {item.zone_no !== 0
                  ? this.renderPriceTypeLimitedAvailbilityText(item)
                  : ''}
              </div>
            ) : null;
          }
        })}
      </div>
    ) : null;
  }

  renderPriceTypeLimitedAvailbilityText(item) {
    if (this.state.numberOfTickets === 0) {
      return null;
    }

    const availabilityData = Object.values(
      this.state.screenZones ? this.state.screenZones : {}
    ).find(
      screenZone =>
        item.zones.filter(zone_no => screenZone.zones.includes(zone_no))
          .length > 0 &&
        screenZone.availableSeats +
          (this.state.numberOfAccessibleSeats > 0
            ? screenZone.availableCompanionSeats
            : 0) >=
          this.state.numberOfTickets - this.state.numberOfAccessibleSeats &&
        screenZone.availableAccessibleSeats >=
          this.state.numberOfAccessibleSeats
    );

    if (
      availabilityData &&
      availabilityData.availableSeats -
        availabilityData.availableHoldCodesSeats ===
        0
    ) {
      if (availabilityData.availableAccessibleSeats > 0) {
        return (
          <span className="syos-level-selector-price-types__item__availability">
            Only{' '}
            {availabilityData.availableHoldCodesSeats > 0
              ? `${availabilityData.availableHoldCodesSeatsMap
                  .map(datum => datum.type.label)
                  .join(', ')}, `
              : null}
            wheelchair and companion seats are available.
          </span>
        );
      }

      return (
        <span className="syos-level-selector-price-types__item__availability">
          Only{' '}
          {availabilityData.availableHoldCodesSeatsMap
            .map(type => type.label)
            .join(', ')}{' '}
          seats are available.
        </span>
      );
    }

    return null;
  }

  handleTicketPriceAmount(value, priceType) {
    let total = 0;
    let totalPrice = 0;
    let selectedPriceTypes = [];

    priceType.count = parseInt(value, 10);

    this.enhanceSectionMap(
      this._selectMapRefs.sections,
      this._selectMapRefs.sectionLabels
    );

    forEach(this.state.availablePriceTypes, item => {
      total += item.count;

      if (item.count > 0) {
        totalPrice += parseFloat(item.price).toFixed(2) * item.count;

        for (let i = 0; i < item.count; i++) {
          selectedPriceTypes.push(item.price_type);
        }
      }
    });

    let numberOfAccessibleSeats =
      total > this.state.numberOfAccessibleSeats
        ? this.state.numberOfAccessibleSeats
        : total;

    this.setState({
      numberOfTickets: total,
      totalPrice: totalPrice,
      selectedPriceTypes: selectedPriceTypes,
      numberOfAccessibleSeats: numberOfAccessibleSeats
    });

    if (total === 10) {
      this.props.updategroupSalesNotice(true);
    }

    this.handleAccessibleSeatAmount(numberOfAccessibleSeats);
  }

  handleAccessibleSeatAmount(value) {
    this.setState(
      {
        numberOfAccessibleSeats: value
      },
      () => {
        this.setState(
          {
            screenZones: this.parseScreenZones()
          },
          () => {
            this.setState(
              {
                sections: this.enhanceSectionMap(
                  this._selectMapRefs.sections,
                  this._selectMapRefs.sectionLabels
                )
              },
              () => {
                this.addSectionHover();
                this.removeSectionHover();
                this.addSectionClick();
              }
            );
          }
        );
      }
    );
  }

  reserveBestAvailableSeats(zoneId = 0) {
    let perfNo = this.state.details.summary.inv_no;
    let packageNo = this.props.initialPackageNo;
    let zone = zoneId > 0 ? zoneId : this.state.selectedZone.zones[0];
    if (this.state.selectedZone.zone_no === 0) {
      zone = 0;
    }

    let numOfSeats = this.state.numberOfTickets;
    let numOfAccessibleSeats = parseInt(this.state.numberOfAccessibleSeats, 10);
    let priceTypes = this.state.selectedPriceTypes;

    this.setState({
      buttonState: CONFIRM_BUTTON_STATES.CONFIRMING
    });

    API.ReserveTicketsEx(
      perfNo,
      packageNo,
      zone,
      priceTypes,
      numOfSeats,
      numOfAccessibleSeats,
      getHoldCodeToBook(
        numOfSeats,
        numOfAccessibleSeats,
        this.props.seatData,
        zone
      ),
      config.features.levelBASelector.bookUnseated
    )
      .then(response => {
        if (
          parseInt(response.result[0], 10) !==
            numOfSeats - numOfAccessibleSeats ||
          parseInt(response.result[1], 10) !== numOfAccessibleSeats
        ) {
          if (
            zone === 0 ||
            this.state.selectedZone.zones.indexOf(zone) ===
              this.state.selectedZone.zones.length - 1
          ) {
            this.setState({
              noticeMessage: true,
              buttonState: CONFIRM_BUTTON_STATES.CONFIRM
            });
          } else {
            this.reserveBestAvailableSeats(
              this.state.selectedZone.zones[
                this.state.selectedZone.zones.indexOf(zone) + 1
              ]
            );
          }
        } else {
          if (
            this.state.displaySeatMapAfterBooking &&
            config.features.levelBASelector.syosEnabled
          ) {
            this.props.updateContext(CONTEXT.SEAT_SELECTION);
            this.setState({
              buttonState: CONFIRM_BUTTON_STATES.CONFIRM
            });
          } else {
            this.props.onComplete.call(null, response);
          }
        }
      })
      .catch(error => {
        this.setState({
          noticeMessage: error.message,
          buttonState: CONFIRM_BUTTON_STATES.CONFIRM
        });
      });
  }

  renderEnhancedNotice() {
    if (this.state.noticeMessage) {
      return (
        <Modal
          onClose={() => {
            this.setState({
              noticeMessage: null
            });
          }}
        >
          <div className="syos-enhanced-notice">
            <div
              className="syos-enhanced-notice__inner"
              dangerouslySetInnerHTML={{
                __html: config.baErrorNoticeMessage.replace(
                  '%tickets%',
                  this.state.numberOfTickets
                )
              }}
            />
          </div>
        </Modal>
      );
    } else {
      return null;
    }
  }

  handleChange(event) {
    this.setState({
      loading: true
    });

    let performanceId = event.target.value;

    API.getDetailsWithDiscounting(
      performanceId,
      0,
      this.props.loginInfo.MOS,
      this.props.loginInfo.promotion_code
    ).then(result => {
      let details = {
        summary: result.Performance,
        webContent: arrayWrap(result.WebContent)
      };

      let priceTypes = result.PriceType.reduce((acc, priceType) => {
        priceType.selected = false;
        priceType.highlighted = false;
        priceType.count = priceType.description === 'Standard' ? 2 : 0;
        acc.push(priceType);
        return acc;
      }, []);

      API.getAllPerformances(details.summary.prod_season_no).then(result => {
        let performance = get(result, 'Performance');
        if (!performance) {
          performance = get(result, 'result');
        }
        let performances = arrayWrap(performance);
        performances = orderBy(performances, ['perf_dt'], ['asc']);

        performances = filter(performances, performance => {
          return performance.description === details.summary.description;
        });

        if (performances.length) {
          this.setState({
            performances: filterPastPerformances(performances),
            currentPerformanceId: performanceId,
            details: details,
            priceTypes: priceTypes
          });
        }

        API.getSeatmapData(
          performanceId,
          0,
          this.props.loginInfo.MOS,
          this.props.loginInfo.promotion_code,
          false
        ).then(result => {
          this.setState(
            {
              seatData: get(result, 'seatsResults'),
              screenData: get(result, 'screensResults.Screens'),
              screenZoneData: get(result, 'screenZoneData')
            },
            () => {
              this.setState({
                screenZones: this.parseScreenZones(),
                loading: false
              });

              this.loadSeatMap();
            }
          );
        });
      });
    });
  }

  parseScreenZones() {
    config = new Config().getConfig();

    let displaySeatMapAfterBooking = false;

    // grouping seat data by the screen number so we get an object of all seats with the screen_no as the key
    let zoneGroups = groupBy(this.props.seatData, 'zone_no');
    let zoneAvailability = {};

    // Build list hold codes for text
    const companionHoldCode = features.getOption('companionSeats', 'holdCodes');
    const accessibilityHoldCode = features.getOption(
      'accessibilitySeats',
      'holdCodes'
    );
    const customTypes = config.seatTypes.customTypes
      .reduce((acc, item) => {
        if (item.holdCodes && item.holdCodes.length > 0) {
          acc.push(item);
        }

        return acc;
      }, [])
      .filter(hc => {
        return (
          hc.holdCodes.filter(x => accessibilityHoldCode.includes(x)).length ===
            0 &&
          hc.holdCodes.filter(x => companionHoldCode.includes(x)).length === 0
        );
      });

    // loop through the screens and find all of the corresponding zone_ids
    // for each screen.
    // Only add the zone_id if the seat is in the allocation.
    for (const key in zoneGroups) {
      if (zoneGroups.hasOwnProperty(key)) {
        const element = zoneGroups[key];
        forEach(element, seat => {
          let seatSectionId = transformID(seat.screen.screen_desc);
          if (!zoneAvailability[seatSectionId]) {
            zoneAvailability[seatSectionId] = {};
          }
          if (!zoneAvailability[seatSectionId][key]) {
            zoneAvailability[seatSectionId][key] = {
              element: [],
              availableSeats: 0,
              availableAccessibleSeats: 0,
              availableCompanionSeats: 0,
              availableHoldCodesSeats: 0,
              availableHoldCodesSeatsMap: []
            };
          }
          zoneAvailability[seatSectionId][key].element.push(seat);

          if (
            config.seatTypes.seatMappings
              .filter(mapping => mapping.status === 'available')
              .map(mapping => mapping.statusCode)
              .indexOf(seat.seat_status.status_code) !== -1
          ) {
            if (detectAccessibilitySeat(seat)) {
              zoneAvailability[seatSectionId][key].availableAccessibleSeats++;
            }

            if (!detectAccessibilitySeat(seat) && !detectCompanionSeat(seat)) {
              zoneAvailability[seatSectionId][key].availableSeats++;
            }

            if (detectCompanionSeat(seat)) {
              zoneAvailability[seatSectionId][key].availableCompanionSeats++;
            }

            if (
              customTypes.some(
                type => type.holdCodes.indexOf(seat.hc_no) !== -1
              )
            ) {
              zoneAvailability[seatSectionId][key].availableHoldCodesSeats++;

              if (
                !zoneAvailability[seatSectionId][
                  key
                ].availableHoldCodesSeatsMap.some(
                  item => item.type.holdCodes.indexOf(seat.hc_no) !== -1
                )
              ) {
                zoneAvailability[seatSectionId][
                  key
                ].availableHoldCodesSeatsMap.push({
                  type: customTypes.find(
                    hc => hc.holdCodes.indexOf(seat.hc_no) !== -1
                  ),
                  amount: 1
                });
              } else {
                zoneAvailability[seatSectionId][
                  key
                ].availableHoldCodesSeatsMap.find(
                  item => item.type.holdCodes.indexOf(seat.hc_no) !== -1
                ).amount++;
              }
            }
          }
        });
      }
    }

    // grouping seat data by the screen number so we get an object of all seats with the screen_no as the key
    let groups = groupBy(this.props.seatData, 'screen_no');
    let screenZones = {};
    const bookUnseated = config.features.levelBASelector.bookUnseated;

    // loop through the screens and find all of the corresponding zone_ids
    // for each screen.
    // Only add the zone_id if the seat is in the allocation.
    let zones = {};
    for (const key in groups) {
      if (groups.hasOwnProperty(key)) {
        const element = groups[key];
        forEach(element, seat => {
          let seatSectionId = transformID(seat.screen.screen_desc);
          if (!zones[seatSectionId]) {
            zones[seatSectionId] = [];
          }

          if (
            (bookUnseated ||
              config.seatTypes.seatMappings
                .filter(mapping => mapping.status === 'available')
                .map(mapping => mapping.statusCode)
                .indexOf(seat.seat_status.status_code) !== -1) &&
            (this.state.numberOfAccessibleSeats > 0 ||
              (!detectAccessibilitySeat(seat) && !detectCompanionSeat(seat)))
          ) {
            zones[seatSectionId].push(seat.zone_no);
          }

          if (this.props.levelSelectorConfig.screenMap) {
            let newSeatSectionId = Object.keys(
              this.props.levelSelectorConfig.screenMap
            ).find(screenMapKey => {
              return (
                this.props.levelSelectorConfig.screenMap[screenMapKey].indexOf(
                  seatSectionId
                ) !== -1
              );
            });

            if (newSeatSectionId) {
              seatSectionId = transformID(newSeatSectionId);
            }
          }

          if (
            !displaySeatMapAfterBooking &&
            config.seatTypes.seatMappings
              .filter(mapping => mapping.status === 'available')
              .map(mapping => mapping.statusCode)
              .indexOf(seat.seat_status.status_code) !== -1 &&
            this.state.sections &&
            this.state.sections.some(
              section => transformID(section.screen) === seatSectionId
            )
          ) {
            displaySeatMapAfterBooking = true;
          }
        });
      }
    }

    Object.keys(zones).forEach(screenDesc => {
      if (bookUnseated) {
        const uniqueZones = uniq(zones[screenDesc]);
        screenZones[screenDesc] = {
          zones: uniqueZones,
          element: uniqueZones.reduce((acc, zone_no) => {
            Object.keys(zoneAvailability).forEach(desc => {
              if (!zoneAvailability[desc][zone_no]) {
                return;
              }
              zoneAvailability[desc][zone_no].element.forEach(item =>
                acc.push(item)
              );
            });
            return acc;
          }, []),
          availableSeats: uniqueZones.reduce((acc, zone_no) => {
            Object.keys(zoneAvailability).forEach(desc => {
              if (!zoneAvailability[desc][zone_no]) {
                return;
              }
              acc = acc + zoneAvailability[desc][zone_no].availableSeats;
            });
            return acc;
          }, 0),
          availableAccessibleSeats: uniqueZones.reduce((acc, zone_no) => {
            Object.keys(zoneAvailability).forEach(desc => {
              if (!zoneAvailability[desc][zone_no]) {
                return;
              }
              acc =
                acc + zoneAvailability[desc][zone_no].availableAccessibleSeats;
            });
            return acc;
          }, 0),
          availableCompanionSeats: uniqueZones.reduce((acc, zone_no) => {
            Object.keys(zoneAvailability).forEach(desc => {
              if (!zoneAvailability[desc][zone_no]) {
                return;
              }
              acc =
                acc + zoneAvailability[desc][zone_no].availableCompanionSeats;
            });
            return acc;
          }, 0),
          availableHoldCodesSeats: uniqueZones.reduce((acc, zone_no) => {
            Object.keys(zoneAvailability).forEach(desc => {
              if (!zoneAvailability[desc][zone_no]) {
                return;
              }
              acc =
                acc + zoneAvailability[desc][zone_no].availableHoldCodesSeats;
            });
            return acc;
          }, 0),
          availableHoldCodesSeatsMap: uniqueZones.reduce((acc, zone_no) => {
            Object.keys(zoneAvailability).forEach(desc => {
              if (!zoneAvailability[desc][zone_no]) {
                return;
              }
              zoneAvailability[desc][
                zone_no
              ].availableHoldCodesSeatsMap.forEach(item => acc.push(item));
            });
            return acc;
          }, [])
        };
      } else {
        const uniqueZones = uniq(zones[screenDesc]);
        screenZones[screenDesc] = {
          zones: uniqueZones,
          element: uniqueZones.reduce((acc, zone_no) => {
            zoneAvailability[screenDesc][zone_no].element.forEach(item =>
              acc.push(item)
            );
            return acc;
          }, []),
          availableSeats: uniqueZones.reduce((acc, zone_no) => {
            acc = acc + zoneAvailability[screenDesc][zone_no].availableSeats;
            return acc;
          }, 0),
          availableAccessibleSeats: uniqueZones.reduce((acc, zone_no) => {
            acc =
              acc +
              zoneAvailability[screenDesc][zone_no].availableAccessibleSeats;
            return acc;
          }, 0),
          availableCompanionSeats: uniqueZones.reduce((acc, zone_no) => {
            acc =
              acc +
              zoneAvailability[screenDesc][zone_no].availableCompanionSeats;
            return acc;
          }, 0),
          availableHoldCodesSeats: uniqueZones.reduce((acc, zone_no) => {
            acc =
              acc +
              zoneAvailability[screenDesc][zone_no].availableHoldCodesSeats;
            return acc;
          }, 0),
          availableHoldCodesSeatsMap: uniqueZones.reduce((acc, zone_no) => {
            zoneAvailability[screenDesc][
              zone_no
            ].availableHoldCodesSeatsMap.forEach(item => acc.push(item));
            return acc;
          }, [])
        };
      }
    });

    if (screenZones['Venue Section']) {
      delete screenZones['Venue Section'];
    }

    this.setState({
      displaySeatMapAfterBooking: displaySeatMapAfterBooking
    });

    return screenZones;
  }

  render() {
    const visibilityStyles = this.state.loading
      ? { visibility: 'hidden' }
      : null;

    const details = this.props.details;
    const webContent = get(details, 'webContent', []);

    return (
      <div
        className="syos-level-selector-container"
        aria-label="Select your own seat"
      >
        {this.props.renderGroupSalesNotice()}
        {this.renderEnhancedNotice()}
        <div className="syos-level-selector__header syos-level-selector__header--has-extra">
          <div className="syos-level-selector__header__details">
            <header className="syos-performance-details">
              {this.state.details ? (
                <h2
                  className="syos-performance-details__title notranslate"
                  dangerouslySetInnerHTML={{
                    __html:
                      details &&
                      displayTitle(
                        this.props.details.summary.description,
                        webContent
                      )
                  }}
                />
              ) : null}
              {this.state.details ? (
                <h3 className="syos-performance-details__subtitle">
                  {features.isEnabled('performanceSelector') ? (
                    <span className="syos-performance-details__date">
                      <div className="syos-performance-selector">
                        <select
                          className="syos-performance-selector__select"
                          value={this.state.currentPerformanceId}
                          onChange={this.handleChange}
                          id="syos-performance-selector"
                          tabIndex={1}
                        >
                          <optgroup label="Select a performance">
                            {this.state.performances.map((performance, idx) => {
                              return (
                                <option value={performance.inv_no} key={idx}>
                                  {formattedDate(performance.perf_dt)}
                                </option>
                              );
                            })}
                          </optgroup>
                        </select>
                      </div>
                    </span>
                  ) : null}
                  <span className="syos-performance-details__facility notranslate">
                    {this.state.details.summary.facility_desc === 'WDCH'
                      ? 'Walt Disney Concert Hall'
                      : this.state.details.summary.facility_desc}
                  </span>
                </h3>
              ) : null}
            </header>
          </div>
          <div className="syos-level-selector__header__extra">
            {features.isEnabled('promoCode') ? (
              <PromoCode onPromoCodeReady={this.props.onPromoCodeReady} />
            ) : null}
          </div>
        </div>

        <LoadingSpinner isActive={this.state.loading} />

        <div style={visibilityStyles} className="syos-level-selector-wrapper">
          <div
            className={`syos-level-selector-container__header
            ${
              this.state.availablePriceTypes.length > 1
                ? 'multiple-price-type'
                : ''
            }`}
          >
            {this.state.availablePriceTypes.map((item, idx) => {
              return (
                <div
                  key={idx}
                  className="ticket-quantity-selector"
                  tabIndex="3"
                  aria-label={`Price type ${item.description}`}
                >
                  <p className="ticket-quantity-selector__pricetype">
                    {item.description}
                  </p>
                  <NumberSelector
                    className="number-selector"
                    value={item.count}
                    handler={this.handleTicketPriceAmount}
                    max={this.state.maxTickets}
                    min={0}
                    priceType={item}
                  />
                </div>
              );
            })}

            <div
              className="ticket-quantity-selector accessability"
              tabIndex="3"
              aria-label="Accessible seats"
            >
              <p className="ticket-quantity-selector__pricetype">
                Accessible seats
              </p>
              <AccessibleSeatSelector
                value={this.state.numberOfAccessibleSeats}
                max={this.state.numberOfTickets}
                handler={this.handleAccessibleSeatAmount}
              />
            </div>
          </div>
          <div className="syos-level-selector-container__cta">
            {this.state.selectedZone && this.state.selectedZone.zone_desc ? (
              <div>
                {this.state.numberOfTickets} Seats at{' '}
                <b>
                  {this.state.selectedZone.priceText !== undefined
                    ? this.state.selectedZone.priceText
                    : toCurrency(this.state.selectedZone.price)}
                </b>
              </div>
            ) : (
              <div>
                <b>Select a price zone</b>
              </div>
            )}
            <button
              tabIndex="8"
              className="syos-button syos-level-selector__button"
              disabled={
                !this.state.selectedZone ||
                this.state.numberOfTickets < 1 ||
                this.state.buttonState === CONFIRM_BUTTON_STATES.CONFIRMING ||
                !this.state.priceTypes.some(x => x.isAvailable)
              }
              onClick={() => {
                this.reserveBestAvailableSeats();
              }}
              dangerouslySetInnerHTML={{
                __html:
                  this.state.buttonState === CONFIRM_BUTTON_STATES.CONFIRM
                    ? config.levelBASelector.labels.confirm
                    : config.levelBASelector.labels.confirming
              }}
            />
          </div>
          <div className="syos-level-pricetype-selector-container">
            <BALevelSelectMap
              sectionGraphic={this.state.sectionGraphic}
              isEnhanced={true}
              ref={component => {
                this._selectMapRefs = component && {
                  el: component._sectionSelectMap,
                  svgEl: component._sectionSelectSvg,
                  sections: component._sections,
                  sectionLabels: component._sectionLabels
                };
              }}
            />
            {this.renderPriceTypesList()}
          </div>
        </div>
        <ReactTooltip />
      </div>
    );
  }
}

LevelBASelectorContainer.propTypes = {
  initialPerformanceId: PropTypes.number,
  initialPackageNo: PropTypes.number,
  details: PropTypes.object.isRequired,
  levelSelectorConfig: PropTypes.object.isRequired,
  selectedZone: PropTypes.object,
  priceTypes: PropTypes.array.isRequired,
  sectionMapping: PropTypes.object.isRequired,
  performances: PropTypes.array,
  loginInfo: PropTypes.object,
  seatData: PropTypes.array,
  onPromoCodeReady: PropTypes.func,
  useSectionGraphic: PropTypes.bool,
  updateContext: PropTypes.func,
  onComplete: PropTypes.func.isRequired,
  updategroupSalesNotice: PropTypes.func,
  renderGroupSalesNotice: PropTypes.func,
  maxTickets: PropTypes.object
};

export default LevelBASelectorContainer;



// WEBPACK FOOTER //
// ./src/javascripts/containers/LevelBASelectorContainer.js